import { render, staticRenderFns } from "./LineChart.vue?vue&type=template&id=13fce643"
import script from "./LineChart.vue?vue&type=script&lang=js"
export * from "./LineChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13fce643')) {
      api.createRecord('13fce643', component.options)
    } else {
      api.reload('13fce643', component.options)
    }
    module.hot.accept("./LineChart.vue?vue&type=template&id=13fce643", function () {
      api.rerender('13fce643', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/inventory-prediction/components/LineChart.vue"
export default component.exports